import {getStateXml} from '../../../_shared/GWTBridge/invoke/server';
import {buildFormServerCall} from '../../services/formService';
import {addFormOperation} from '../../../_shared/GWTBridge/invoke/netForm';
import {formsStore} from '../../Form/stores/FormsStore';
import {Keys} from '../../Form/consts/keys';

function getFormStateXml() {
    if (formsStore.isReactView) {
        addFormOperation({
            ...formsStore.currentForm?.formState,
            key: Keys.None
        });
    }
    return getStateXml();
}

export function formOpenSearchField(isSearch) {
    const key = isSearch ? 38 : -18;
    const methodName = 'FormKey';
    //the reason name is used in setIsTypingOnServer in gwt;
    //if you change it here, change there too;
    const reason = 'Open search/choose box';
    const statexml = getFormStateXml();
    const parameters = {statexml: [statexml], key: [key.toString()]};
    // writeLog(`${reason} (${methodName})`, `key: ${key}`)
    return buildFormServerCall(methodName, parameters, reason, false, false, true);
}

export function formSearchFieldAction(action, searchQuery) {
    const methodName = 'FormSearch';
    const reason = 'Choose search value';
    const statexml = getFormStateXml();
    const parameters = {statexml: [statexml], mode: [action.toString()], editvalue: [searchQuery]};
    // writeLog(`${reason} (${methodName})`, `mode: ${action.toString()}, editvalue: ${searchQuery}`)
    return buildFormServerCall(methodName, parameters, reason, false, false);
}

export function formSearchNextPage(page, searchQuery) {
    const methodName = 'FormSearchPage';
    const reason = 'Search scroll';
    const statexml = getFormStateXml();
    const parameters = {statexml: [statexml], page: [page.toString()], editvalue: [searchQuery]};
    return buildFormServerCall(methodName, parameters, reason, false, false);
}
